// Display strings for the dashboard hero (PHX-151).
export const PORTFOLIO_TERMS = {
  totalActivePortfolio: "Total active portfolio",
  addInvestment: "Add investment",
  principalAmount: "Principal amount",
  totalAccruedInterest: "Total accrued interest",
  totalMonthlyPayments: "Total monthly payments",
  nextMonthlyPayment: "Next monthly payment",
  viewAllEarnings: "View all earnings",
  viewBreakdown: "View breakdown",
  // The two group headings that split the summary card.
  totalsGroup: "Totals",
  accountTypeGroup: "By account type",
  // Stands in for the monthly-payment figure on account types whose bonds all
  // compound — distinct from $0, which would mean "scheduled, but nothing due".
  notApplicable: "Not applicable",
  valuesAsOfToday: "All values are as of today.",
  breakdownEyebrow: "Investments",
  breakdownTitle: "Breakdown by investment type",
  emptyStateHeadlinePrefix: "Start earning up to",
  emptyStateHeadlineHighlight: "13%",
  emptyStateHeadlineSuffix: "in annual returns",
  emptyStateBody:
    "Making an investment is quick, easy, and secure. Explore our offerings to get started.",
  startInvesting: "Start Investing",
};

// Copy behind the info buttons on the portfolio KPIs. Each one explains what
// the figure counts (and, where it matters, what it deliberately leaves out),
// so the numbers on screen can be reconciled against each other. Keyed to
// match PORTFOLIO_TERMS above.
export const PORTFOLIO_INFO = {
  totalActivePortfolio:
    "What your settled investments are worth today: your principal plus any interest that has compounded into your bonds. Monthly payments already sent to you aren't counted here — that cash has left the portfolio.",
  principalAmount:
    "The total amount you have invested across your settled bonds, before any interest. Pending investments join this figure once they settle.",
  totalAccruedInterest:
    "Interest your compounding bonds have earned and added to their value instead of paying out. It stays invested until the bond matures or you redeem it.",
  totalMonthlyPayments:
    "Interest already paid out to you in cash from bonds set to monthly payments, added up since your first payment.",
  // The label says "payment" but the figure also counts interest compounding
  // back into the bonds, so this has to spell out both halves — otherwise the
  // number won't reconcile against the monthly payments actually banked.
  nextMonthlyPayment:
    "Everything your bonds are scheduled to earn on your next payment date: cash paid out to you as monthly payments, plus interest compounding into bonds you hold. View breakdown shows it investment by investment.",
};
